export default __webpack_public_path__ + "static/media/monitorwise-mark-dark.e5ea4663.svg";